export default __webpack_public_path__ + "static/media/IBMPlexSans-SemiBold.ef11554b.woff";